import React from 'react';
import NFTLandingPage from './NFTLandingPage';

function App() {
  return <NFTLandingPage />;
}

export default App;